import React, { useState, useRef } from "react";
import { MdCancel } from "react-icons/md";
import Button from "../../../../components/Button/Button";
import TextInput from "../../../../components/Input/Input";
import { MdImage } from "react-icons/md";
import { storage } from "../../../../firebaseconfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Loader from "../../../../components/Loader/Loader";
import Select from "react-select";
import { ProductService } from "../ProductService";
import { toast } from "react-toastify";

const AddProduct: React.FC<any> = ({ onClose, categories }) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [laoding, setLoading] = useState<boolean>(false);
  const [category, setCategory] = useState<string>("");
  const [price, setPrice] = useState<string>("");

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const randomId = Math.random().toString(36).substring(2, 10);

    if (file) {
      const fileRef = ref(storage, `products/${file.name + randomId}`);
      setLoading(true);
      uploadBytes(fileRef, file)
        .then(async () => {
          const resURL = await getDownloadURL(fileRef);
          setSelectedImage(resURL);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    }
  };

  const onHandleSave = async () => {
    const dataBody = {
      title: name,
      description,
      image_url: selectedImage,
      category,
      price,
    };
    setLoading(true);
    const res: any = await ProductService.createProduct(dataBody);
    setLoading(false);
    if (res.status === 201) {
      toast.success("Product added successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      onClose();
    } else {
      toast.error("something wents wrong!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleChange = (selectedOption: any) => {
    setCategory(selectedOption.value);
    console.log("Selected option:", selectedOption);
  };

  return (
    <div className="w-full h-full bg-black bg-opacity-30 fixed z-10 top-0 right-0 flex items-center justify-center">
      <div className="w-[25rem] h-fit p-5 bg-white rounded-xl shadow-md">
        <div className="flex justify-between items-center">
          <h3 className="font-poppins font-medium text-md">Add Product</h3>
          <h3
            onClick={onClose}
            className="font-poppins font-medium text-md cursor-pointer"
          >
            <MdCancel />
          </h3>
        </div>

        <div>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: "none" }}
            ref={fileInputRef}
          />
          <div
            className={`w-full flex flex-col items-center justify-center h-[10rem] mt-3 rounded-xl cursor-pointer border-2 border-dashed border-gray-300 ${
              selectedImage ? "!border-0" : "border-2"
            }`}
            onClick={() => {
              fileInputRef.current?.click();
            }}
          >
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="Selected"
                className="h-full w-full object-cover rounded-xl"
              />
            ) : (
              <>
                <MdImage size={40} className="text-gray-300" />
                <h3 className="font-poppins font-medium text-md text-gray-800">
                  Add Image
                </h3>
              </>
            )}
          </div>
        </div>

        <TextInput
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <textarea
          className="w-full border-[1px] px-2 py-2 rounded-lg mt-3 border-black-200 outline-none resize-none"
          placeholder="Description"
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          rows={4} // Adjust the number of rows as needed
          draggable="false"
        />

        <Select
          className="mt-3 outline-none rounded-lg"
          placeholder="Select Category"
          options={categories}
          onChange={handleChange}
        />
        <TextInput
          placeholder="Price"
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />

        <Button
          onClick={onHandleSave}
          disabled={false}
          className="!bg-blue-500 text-white !w-full"
        >
          {laoding ? <Loader /> : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default AddProduct;
